import { Injectable } from '@angular/core';
import { ApiService, GetRequestArguments, Refresh } from './api.service';
import { BehaviorSubject } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PublicHolidayService {
  private currentYear: number = new Date().getFullYear();

  public $range = new BehaviorSubject([
    this.formatDate(new Date(this.currentYear - 1, 0, 1)),
    this.formatDate(new Date(this.currentYear + 1, 11, 31)),
  ]);

  public $publicHolidays = new BehaviorSubject([]);
  private url = 'getPublicHoliday';
  private groupKey = 'publicHoliday';
  private hour = 60 * 60;
  public $tenantCountry = new BehaviorSubject([]);

  constructor(private api: ApiService) {}

  private formatDate(date: Date): string {
    const year = date.getFullYear().toString().padStart(4, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}${month}${day}`;
  }

  loadCountries(refresh: Refresh = 'expired') {
    const args = new GetRequestArguments({
      url: ['countries'],
      cacheGroup: this.groupKey,
      refresh,
      ttl: this.hour * 24 * 7,
      delayed: false,
    });
    const call = this.api.cachedGetRequest(args);
    call.subscribe((countries) => {
      this.api.updateObservable(
        countries.find((c) => c.is_tenant_country === true),
        this.$tenantCountry
      );
    });
    return call;
  }

  loadAll(refresh: Refresh = 'expired', country: string = '') {
    if (country.length === 0) {
      this.loadCountries();
      this.$tenantCountry.subscribe((item) => {
        if (item['code']) {
          const args = new GetRequestArguments({
            url: [this.url],
            cacheGroup: this.groupKey,
            ttl: this.hour * 24 * 7,
            refresh,
            delayed: false,
            params: new HttpParams()
              .set('date_from', this.$range.value[0].replaceAll('-', ''))
              .set('date_to', this.$range.value[1].replaceAll('-', ''))
              .set('country', item['code']),
          });

          this.api.cachedGetRequest(args).subscribe((res) => {
            this.api.updateObservable(res, this.$publicHolidays);
          });
        }
      });
    } else {
      const args = new GetRequestArguments({
        url: [this.url],
        cacheGroup: this.groupKey,
        ttl: this.hour * 24 * 7,
        refresh,
        delayed: false,
        params: new HttpParams()
          .set('date_from', this.$range.value[0].replaceAll('-', ''))
          .set('date_to', this.$range.value[1].replaceAll('-', ''))
          .set('country', country),
      });

      this.api.cachedGetRequest(args).subscribe((res) => {
        this.api.updateObservable(res, this.$publicHolidays);
      });
    }
  }

  loadByDateRange(
    dateFrom: string,
    dateTo: string,
    country: string = '',
    refresh: Refresh = 'all'
  ) {
    if (country.length === 0) {
      this.loadCountries();
      this.$tenantCountry.subscribe((item) => {
        if (item['code']) {
          const args = new GetRequestArguments({
            url: [this.url],
            cacheGroup: this.groupKey,
            ttl: this.hour * 24 * 7,
            refresh,
            delayed: false,
            params: new HttpParams()
              .set('date_from', dateFrom.replaceAll('-', ''))
              .set('date_to', dateTo.replaceAll('-', ''))
              .set('country', item['code']),
          });

          this.api.cachedGetRequest(args).subscribe((res) => {
            this.api.updateObservable(res, this.$publicHolidays);
          });
        }
      });
    } else {
      const args = new GetRequestArguments({
        url: [this.url],
        cacheGroup: this.groupKey,
        ttl: 20,
        refresh,
        params: new HttpParams()
          .set('date_from', dateFrom.replaceAll('-', ''))
          .set('date_to', dateTo.replaceAll('-', ''))
          .set('country', country),
      });

      this.api.cachedGetRequest(args).subscribe((res) => {
        this.api.updateObservable(res, this.$publicHolidays);
      });
    }
  }
}
